import { Button, PageHeader } from 'components';
import { Form, Input, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useCompanyCategory from '../useCompanyCategory';

const CompanyCategoryEdit = ({ isNew }) => {
  const { t } = useTranslation();
  const { form, handleCreateOrUpdate, loading } = useCompanyCategory(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const title = isNew
    ? t('CREARE CATEGORIE INSEGNE')
    : t('MODIFICA CATEGORIE INSEGNE');

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          initialValues={{
            title: '',
            nego_tov_id: '',
            nego_sov_id: '',
            nego_rov_id: '',
          }}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label={t('Titolo')} name='title'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={t('Nome commerciale')} name='commercial_name'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('NEGO ID (TOV)')} name='nego_tov_id'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('NEGO ID (SOV)')} name='nego_sov_id'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('NEGO ID (ROV)')} name='nego_rov_id'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={handleCreate}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={loading}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CompanyCategoryEdit;
